/** 页脚富文本内容 dataKey（与后台 portal_footer_config 约定一致） */
export const FooterConfigDataKeyEnum = {
  ABOUT_PLATFORM: {
    code: 'about_platform',
    title: '关于平台'
  },
  COMMON_QUESTION: {
    code: 'common_question',
    title: '常见问题'
  }
}

export const FOOTER_RICH_CONTENT_KEY_CODES = Object.values(FooterConfigDataKeyEnum).map(
  (item) => item.code
)

export function getFooterRichContentTitle(dataKey) {
  const item = Object.values(FooterConfigDataKeyEnum).find((entry) => entry.code === dataKey)
  return item?.title || '内容详情'
}
